import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import api from "@/lib/api";
import { Users, Calendar, ShieldCheck, Receipt, DollarSign } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
  }, []);

  const cards = stats
    ? [
        { label: "Total Users", value: stats.users, icon: Users },
        { label: "Players", value: stats.players, icon: ShieldCheck },
        { label: "Camps", value: stats.camps, icon: Calendar, sub: `${stats.open_camps} open` },
        { label: "Registrations", value: stats.registrations_total, icon: Receipt, sub: `${stats.registrations_confirmed} confirmed · ${stats.registrations_pending} pending` },
        { label: "Paid Transactions", value: stats.payments_paid, icon: DollarSign },
        { label: "Total Revenue", value: `$${stats.total_revenue?.toFixed(2) || "0.00"}`, icon: DollarSign },
      ]
    : [];

  return (
    <AdminLayout>
      <div className="p-8 max-w-7xl">
        <div className="label-overline text-[#E63946]">Control Room</div>
        <h1 data-testid="admin-dashboard-title" className="font-display text-4xl uppercase tracking-tighter mt-3">
          Platform Overview
        </h1>
        <p className="text-sm text-slate-600 mt-2">Real-time platform metrics across CBR Prospects.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          {cards.map((c) => (
            <div key={c.label} className="bg-white border border-slate-200 p-6 rounded-sm">
              <div className="flex items-start justify-between">
                <div className="label-overline">{c.label}</div>
                <c.icon className="w-5 h-5 text-[#E63946]" />
              </div>
              <div className="font-data text-5xl text-[#0A192F] mt-3">{c.value}</div>
              {c.sub && <div className="text-xs text-slate-500 mt-2">{c.sub}</div>}
            </div>
          ))}
        </div>

        <div className="mt-12 border-l-4 border-[#E63946] bg-white p-6">
          <div className="label-overline text-[#E63946]">Phase 1 · Foundation MVP</div>
          <p className="text-sm text-slate-700 mt-2 leading-relaxed">
            Foundation systems are live: auth, player profiles, camp management, registration, digital waivers, and
            Stripe payments. Verified metrics, evaluations, leaderboards, and rankings are scheduled for Phase 2/3.
          </p>
        </div>
      </div>
    </AdminLayout>
  );
}
